import { z } from 'zod';
/**
 * Bilingual string pair used throughout the data model (PRD §7, §10.1).
 *
 * Every student-facing piece of content (lesson titles, scenario context,
 * tutor intros, feedback text) is stored as `{ en, ja }`. The UI picks the
 * locale at render time via `pickBilingual`.
 *
 * Empty strings are rejected to catch the "field accidentally left blank"
 * authoring class of bug. If a field genuinely has no localized form, omit
 * the bilingual wrapper entirely.
 */
export const bilingualSchema = z.object({
    en: z.string().min(1, 'en must not be empty'),
    ja: z.string().min(1, 'ja must not be empty'),
});
/**
 * Pick a localized value from a bilingual pair. Default locale is Japanese
 * (per PRD §10.2: Japanese is the default surface; English is available
 * per-user).
 */
export function pickBilingual(value, locale = 'ja') {
    return locale === 'en' ? value.en : value.ja;
}
//# sourceMappingURL=bilingual.js.map